import { debounce, type DebouncedFunc } from 'lodash-es';
import { useMemo, useRef } from 'react';
import type { AnyFn } from './types';

/**
 * 为提交函数添加防抖功能
 * @param fn 执行函数
 * @returns
 */
export function useSubmitFn<T extends AnyFn>(
  fn: T,
  wait = 1000,
): DebouncedFunc<T> {
  const fnRef = useRef<T>(fn);
  fnRef.current = fn;

  return useMemo(() => {
    return debounce(
      (...args: Parameters<T>): ReturnType<T> => {
        return fnRef.current(...args);
      },
      wait,
      {
        leading: true,
        trailing: false,
      },
    );
  }, []);
}
